// @core/api/endpoints/booking/update_booking_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingNumberingSchemeResponse,
  UpdateBookingNumberingSchemeRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Update numbering scheme
 * Updates a booking numbering scheme.
 */
export async function UpdateBookingNumberingScheme(
  scheme_id: string,
  data: UpdateBookingNumberingSchemeRequest,
  options?: RequestOptions
): Promise<BookingNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.put<BookingNumberingSchemeResponse>(requestPath, data, requestOptions);
}
